<template>
  <HorizontalBarChart v-bind:title="title" v-bind:data="data" v-bind:labels="labels" />
</template>

<script>
import HorizontalBarChart from "@/components/management/statistics/common/HorizontalBarChart";
import { getAccessByLanguagesChartData } from "@/api/statisticsV2";

export default {
  components: {
    HorizontalBarChart,
  },
  data() {
    return {
      title: "Access by Languages",
      data: [],
      labels: [],
    };
  },
  methods: {
    async getData(startDate, endDate) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByLanguagesChartData(startDate, endDate);
        this.labels = response.data.name;
        this.data = response.data.count;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
